<template>
  <v-form ref="listQualificationMethodForm">
    <v-container>
      <!-- Add Delete Button -->
      <v-col class="text-right">
        <v-btn :to="'qualificationMethod/create'" class="primary" small>Add</v-btn>
        <v-btn @click="deactiveQualificationMethod" class="ml-2" small color="#eee">
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
        <v-btn @click="$refreshDataTable" class="ml-2" small color="#eee">
          <v-icon small>mdi-refresh</v-icon>
        </v-btn>
      </v-col>
      <!-- Datatable -->
      <datatable
        ref="qualificationMethod_datatable"
        :tableOption="tableOption"
        :tableItemSlot="tableItemSlot"
      />
    </v-container>
  </v-form>
</template>
<script>
import datatable from '@/components/datatable.vue'
export default {
  components: {
    datatable
  },
  created () {
  },
  data () {
    return {
      loading: true,
      selected: [],
      dialog: false,
      tableOption: {
        url: 'getQualificationMethodAll',
        editUrl: 'qualificationMethod/edit',
        deleteRoute: 'deactiveQualificationMethod',
        moduleName: 'qualificationMethod',
        headers: [
          { text: 'Actions', value: 'action', sortable: false, align: 'center', width: 80 },
          { text: 'Name', align: 'start', value: 'name' },
          { text: 'Status', value: 'status', align: 'center' },
        ]
      },
      tableItemSlot: {
        status: {
          0: { color: 'green', text: 'Active' },
          1: { color: 'orange', text: 'Inactive' }
        }
      },
    }
  },
  watch: {
    options: {
      handler () {
      },
      deep: true,
    },
  },
  mounted () {
  },
  methods: {
    deactiveQualificationMethod () {
      this.$refs.qualificationMethod_datatable.massDeleteTableData()
    },
  },
}
</script>
<style lang="css">
.elevation-1 {
  table-layout: flex !important;
}
/* .v-data-table-header > tr > th:first-child{
  background: red;
} */
</style>
